<template>
  <div>
    <el-row class="row">
      <el-col :span="24">
        <el-card style="margin-left: 16px;">
          <span>商店访问地址：</span>
          <a target="_blank" :href="marketInfo && marketInfo.marketURL">{{
            marketInfo && marketInfo.marketURL
          }}</a>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="row">
      <el-col v-permit="'User.Market.Order.List'" :span="12">
        <el-card class="row-card">
          <div slot="header" class="clearfix">
            <span class="title">商店订单</span>
            <router-link
              :to="{ name: 'storOrderManage', params: { orderState: 'all' } }"
              style="float: right; padding: 3px 0"
              type="text"
              >查看更多</router-link
            >
          </div>
          <div v-loading="orderOverviewLoading">
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.newOrderNumMonth }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">月新增订单</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.toReviewOrderNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">待审核订单</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.todeliveryOrderNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">待交付订单</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-red">
                    {{ orderOverview.abnormalOrderNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">异常订单</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col v-permit="'User.Market.Order.List'" :span="12">
        <el-card class="row-card">
          <div slot="header" class="clearfix">
            <span class="title">月流水</span>
            <router-link
              :to="{ name: 'marketIntegral' }"
              style="float: right; padding: 3px 0"
              type="text"
              >查看更多</router-link
            >
          </div>
          <div v-loading="orderOverviewLoading">
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.newIncome }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">新购收入</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.renewalIncome }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">续费收入</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ orderOverview.balance }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">余额</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="row">
      <el-col v-if="isShowApp || havePerm('User.Market.Order.List')" :span="24">
        <el-card class="row-card">
          <a-tabs
            :default-active-key="
              isShowApp
                ? 'traffic'
                : havePerm('Market.Order.List')
                ? 'income'
                : ''
            "
            size="large"
            :tab-bar-style="{ marginBottom: '24px' }"
          >
            <a-tab-pane
              v-if="isShowApp"
              loading="true"
              tab="访问量"
              key="traffic"
            >
              <el-col :span="16" v-loading="appOverviewLoading">
                <bar :data="accessInfoData" title="访问量趋势" />
              </el-col>
              <el-col :span="8" v-loading="appOverviewLoading">
                <rank-list title="产品排行榜" :list="appAccessInfoRankList" />
              </el-col>
            </a-tab-pane>

            <a-tab-pane
              v-if="havePerm('User.Market.Order.List')"
              loading="true"
              tab="金额收入"
              key="income"
            >
              <el-col :span="16" v-loading="orderOverviewLoading">
                <bar :data="incomeData" title="收入趋势" />
              </el-col>
              <el-col :span="8" v-loading="orderOverviewLoading">
                <rank-list title="产品排行榜" :list="appIncomeRankList" />
              </el-col>
            </a-tab-pane>
          </a-tabs>
        </el-card>
      </el-col>
    </el-row>
    <el-row class="row">
      <el-col v-permit="'User.Market.Application.List'" :span="8">
        <el-card class="row-card">
          <div slot="header" class="clearfix">
            <span class="title">应用信息</span>
            <router-link
              :to="{ name: 'appManage' }"
              style="float: right; padding: 3px 0"
              type="text"
              >查看更多</router-link
            >
          </div>
          <div v-loading="appOverviewLoading">
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ appOverview.upShelvesAppNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">
                    上架应用数量
                  </p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ appOverview.newAppNumMonth }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">月新增应用</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ appOverview.newCustomerMonth }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">月新增客户</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col v-permit="'User.Deliver.DeliveryApp.List'" :span="8">
        <el-card class="row-card">
          <div slot="header" class="clearfix">
            <span class="title">交付信息</span>
            <router-link
              :to="{ name: 'deliveryAppsrManage' }"
              style="float: right; padding: 3px 0"
              type="text"
              >查看更多</router-link
            >
          </div>
          <div v-loading="deliveryOverviewLoading">
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ deliveryOverview.regionNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">
                    交付集群数量
                  </p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ deliveryOverview.runningDeliveryAppNum }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">
                    服务中应用数量
                  </p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ deliveryOverview.deliveryAppNumMonth }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">月交付应用</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
      <el-col v-permit="'User.Market.MarketWarningNotify.List'" :span="8">
        <el-card class="row-card">
          <div slot="header" class="clearfix">
            <span class="title">预警信息</span>
            <router-link
              :to="{ name: 'warningMessage' }"
              style="float: right; padding: 3px 0"
              type="text"
              >查看更多</router-link
            >
          </div>
          <div v-loading="messageOverviewLoading">
            <div class="statistical-container flex-box has-separation">
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-red">
                    {{ messageOverview.countNew }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">新预警</p>
                </div>
              </div>
              <div class="flex-item">
                <div class="statistical-box">
                  <p class="statistical-num fs-20 lh-1 color-primary">
                    {{ messageOverview.countFinish }}
                  </p>
                  <p class="statistical-label fs-14 lh-1 m-t-20">已处理</p>
                </div>
              </div>
            </div>
          </div>
        </el-card>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import { getOverviewAboutApp } from '@/api/app';
import { getOverviewAboutDelivery } from '@/api/delivery';
import { getOverviewAboutMessage } from '@/api/message';
import { getOverviewAboutOrder } from '@/api/stores';
import Bar from '@/components/Charts/Bar';
import RankList from '@/components/Charts/RankList';
import { havePerm, haveRoutePerms } from '@/utils/auth';
import { errorHandle } from '@/utils/error';
export default {
  components: { Bar, RankList },
  data() {
    return {
      havePerm,
      haveRoutePerms,
      incomeData: [],
      accessInfoData: [],
      appIncomeRankList: [],
      appAccessInfoRankList: [],
      activeKey: 'traffic',
      appOverviewLoading: true,
      appOverview: {
        upShelvesAppNum: 0,
        newAppNumMonth: 0,
        newCustomerMonth: 0
      },
      messageOverviewLoading: true,
      messageOverview: {
        countNew: 0,
        countFinish: 0
      },
      orderOverview: {
        newOrderNumMonth: 0,
        toReviewOrderNum: 0,
        todeliveryOrderNum: 0,
        abnormalOrderNum: 0,
        newIncome: 0,
        renewalIncome: 0,
        balance: 0
      },
      orderOverviewLoading: true,
      deliveryOverview: {
        regionNum: 0,
        runningDeliveryAppNum: 0,
        deliveryAppNumMonth: 0
      },
      deliveryOverviewLoading: true
    };
  },
  computed: {
    marketID() {
      return this.$store.state.enterprise.enterpriseInfo.marketID;
    },
    marketInfo() {
      return this.$store.state.stores.marketInfo;
    },
    isShowApp() {
      return haveRoutePerms([
        'User.Market.Application.List',
        'User.Market.Application.SelfList'
      ]);
    }
  },
  created() {
    if (this.isShowApp) {
      this.getAppOverview();
    }
    if (havePerm('User.Market.MarketWarningNotify.List')) {
      this.getMessageOverview();
    }
    if (havePerm('User.Market.Order.List')) {
      this.getOrderOverview();
    }
    if (havePerm('User.Deliver.DeliveryApp.List')) {
      this.getDeliveryOverview();
    }
  },

  methods: {
    getAppOverview() {
      getOverviewAboutApp({ marketID: this.marketID })
        .then((re) => {
          this.appOverview = re;
          this.appOverviewLoading = false;
          const accessInfoData = [];
          re.dayStatistics &&
            re.dayStatistics.map((item) => {
              accessInfoData.push({
                x: item.time,
                y: item.accessCount
              });
            });
          this.accessInfoData = accessInfoData;
          const appAccessInfoRankList = [];
          re.appRank &&
            re.appRank.map((item) => {
              appAccessInfoRankList.push({
                name: item.appName,
                total: item.accessCount
              });
            });
          this.appAccessInfoRankList = appAccessInfoRankList;
        })
        .catch((err) => {
          errorHandle(err);
          this.appOverviewLoading = false;
        });
    },
    getMessageOverview() {
      getOverviewAboutMessage()
        .then((re) => {
          this.messageOverview = re;
          this.messageOverviewLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.messageOverviewLoading = false;
        });
    },
    getOrderOverview() {
      getOverviewAboutOrder({ marketID: this.marketID })
        .then((re) => {
          this.orderOverview = re;
          this.orderOverviewLoading = false;
          const incomeData = [];
          re.dayStatustics &&
            re.dayStatustics.map((item) => {
              incomeData.push({
                x: item.time,
                y: item.incomeSum
              });
            });
          this.incomeData = incomeData;
          const appIncomeRankList = [];
          re.appIncomeStatistics &&
            re.appIncomeStatistics.map((item) => {
              appIncomeRankList.push({
                name: item.appName,
                total: item.incomeSum
              });
            });
          this.appIncomeRankList = appIncomeRankList;
        })
        .catch((err) => {
          errorHandle(err);
          this.orderOverviewLoading = false;
        });
    },
    getDeliveryOverview() {
      getOverviewAboutDelivery({ marketID: this.marketID })
        .then((re) => {
          this.deliveryOverview = re;
          this.deliveryOverviewLoading = false;
        })
        .catch((err) => {
          errorHandle(err);
          this.deliveryOverviewLoading = false;
        });
    }
  }
};
</script>

<style>
.title {
  border-left: 2px solid #3296fa;
  padding-left: 8px;
}
.row {
  margin-bottom: 16px;
}
.row-card {
  margin-left: 16px;
  min-height: 200px;
}
</style>



// WEBPACK FOOTER //
// src/views/generalUser/myApp/components/market.vue